import { Badge } from '@/components/ui/Badge';
import type { ActiveContractStatus } from '@/types/api';

/**
 * ContractStatusBadge - EIN gemeinsames deutsches Label-Set für den
 * Vertrags-Mapping-Status eines Kunden (`active_contract_status`).
 *
 * Ersetzt die vormals drei divergierenden Label-Sets (EN/DE gemischt) in
 * Kundenliste und Kunden-Detail:
 *   mapped   -> "Aktiver Vertrag" (success)
 *   unmapped -> "Mapping fehlt"   (warning)
 *   none     -> "Kein Vertrag"    (neutral)
 *
 * Sind noch keine Stats geladen (status == undefined), fällt die Anzeige auf
 * ein hartes Signal aus dem Kunden zurück (`fallbackHasContract`, z.B.
 * vorhandene Invoice-Ninja-Client-ID). Ohne Fallback wird "–" angezeigt.
 */

interface ContractStatusBadgeProps {
  status: ActiveContractStatus | null | undefined;
  /** Hard-Signal aus dem Kunden, falls `status` (noch) nicht geladen ist. */
  fallbackHasContract?: boolean;
}

export function ContractStatusBadge({
  status,
  fallbackHasContract,
}: ContractStatusBadgeProps): JSX.Element {
  if (status === 'mapped') return <Badge tone="success">Aktiver Vertrag</Badge>;
  if (status === 'unmapped') return <Badge tone="warning">Mapping fehlt</Badge>;
  if (status === 'none') return <Badge tone="neutral">Kein Vertrag</Badge>;

  // status nicht geladen -> Fallback auf hartes Kunden-Signal.
  if (fallbackHasContract === true) return <Badge tone="warning">Mapping fehlt</Badge>;
  if (fallbackHasContract === false) return <Badge tone="neutral">Kein Vertrag</Badge>;
  return <Badge tone="neutral">–</Badge>;
}
